var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.166,
    height: 47.017,
    viewBox: "0 0 67.166 47.017",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(-7883.31 -6713.789)",
    opacity: 0.497,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M7920.462,6715.888a17.862,17.862,0,0,1,6.507,5.771,11.738,11.738,0,0,1,16.791,10.6,12.6,12.6,0,0,1-.42,3.254,13.7,13.7,0,0,1,5.2,4.984,13.035,13.035,0,0,1,1.941,6.874,13.313,13.313,0,0,1-1.784,6.77,13.09,13.09,0,0,1-4.88,4.88,13.324,13.324,0,0,1-6.77,1.784h-38.62a14.588,14.588,0,0,1-7.557-2.046,15.4,15.4,0,0,1-5.51-5.51,14.59,14.59,0,0,1-2.046-7.557,14.838,14.838,0,0,1,2.78-8.764,14.637,14.637,0,0,1,7.294-5.51,17.959,17.959,0,0,1,2.729-8.868,18.427,18.427,0,0,1,6.717-6.4,18.553,18.553,0,0,1,17.631-.262Zm-16.162,3.3a15.412,15.412,0,0,0-5.51,5.51,14.591,14.591,0,0,0-2.047,7.557,14.142,14.142,0,0,0,.105,1.784,11.676,11.676,0,0,0-7.241,3.936,11.244,11.244,0,0,0-2.938,7.714,11.753,11.753,0,0,0,11.754,11.754h38.62a10.086,10.086,0,0,0,7.661-16.634,10.086,10.086,0,0,0-6.087-3.411,7.929,7.929,0,0,0,1.784-5.143,8.092,8.092,0,0,0-2.466-5.93,8.215,8.215,0,0,0-6.035-2.466,7.988,7.988,0,0,0-6.087,2.729,14.89,14.89,0,0,0-5.456-6.821,15.034,15.034,0,0,0-16.058-.578Zm12.226,31.17a1.209,1.209,0,0,1-.892.367h-.84a1.254,1.254,0,0,1-1.259-1.259v-15.848l-7.137,7.137a1.3,1.3,0,0,1-.944.42.993.993,0,0,1-.839-.42l-.63-.524a1.532,1.532,0,0,1-.315-.944,1.136,1.136,0,0,1,.315-.84l10.389-10.391a1.279,1.279,0,0,1,1.68,0l10.39,10.391a1.135,1.135,0,0,1,.314.84,1.531,1.531,0,0,1-.314.944l-.63.524a1,1,0,0,1-.839.42,1.3,1.3,0,0,1-.945-.42l-7.136-7.137v15.848A1.211,1.211,0,0,1,7916.525,6750.363Z",
    transform: "translate(0 0)",
    fill: "#727272"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uploader.7e648ed3d4128ce7cdd7c40ae408deda.svg";